import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  IconButton,
  Paper,
  Stack,
  SxProps,
  Theme,
  Typography,
  useTheme,
} from "@mui/material";
import { useToggle } from "@/shared/base/hooks/useToggle";
import React from "react";
import { MdOutlineClose } from "react-icons/md";
import { useCssMediaQuery } from "../../hooks/useCssMediaQuery";

export interface ActionModalProps {
  isOpen: boolean;
  hideCloseIcon?: boolean;
  maxWidth?: DialogProps["maxWidth"];
  onClose?: () => void;
  renderHeader?: () => React.ReactNode;
  renderBody?: () => React.ReactNode;
  renderFooter?: () => React.ReactNode;
  width?: DialogProps["maxWidth"];
  sx?: SxProps<Theme> | undefined;
}

function calcModalWidth(width: DialogProps["maxWidth"]) {
  const defaultWidth = "700px";
  switch (width) {
    case "xs":
      return "600px";
    case "sm":
      return defaultWidth;
    case "md":
      return "900px";
    case "lg":
      return "1200px";
    case "xl":
      return "1536px";
    default:
      return defaultWidth;
  }
}

export function ActionModal(props: ActionModalProps) {
  const { palette } = useTheme();
  const { sm: smDown } = useCssMediaQuery("down");

  return (
    <Dialog
      maxWidth={props.maxWidth || "sm"}
      open={props.isOpen}
      PaperComponent={Paper}
      PaperProps={{
        sx: {
          backgroundColor: palette.background.default,
          backgroundImage: "unset",
          border: `1px solid ${palette.divider}`,
          margin: smDown ? "0px" : "initial",
          maxWidth: "100%",
          width: calcModalWidth(props.width),
          ...props?.sx,
        },
      }}
      style={{
        backdropFilter: "blur(4px)",
      }}
    >
      {!props.hideCloseIcon ? (
        <Box
          sx={{
            position: "absolute",
            top: "12px",
            right: "12px",
          }}
        >
          <IconButton size="medium" onClick={props.onClose}>
            <MdOutlineClose />
          </IconButton>
        </Box>
      ) : null}

      {props?.renderHeader?.()}
      {props?.renderBody?.()}
      {props?.renderFooter?.()}
    </Dialog>
  );
}
